import { defineStore } from "pinia";
import { instance } from "..";
import { useAdaptProgressStore } from "./adapt-progress";
import { StatusProgress } from "./adapt-progress";
export const store = defineStore({
  id: "adapt-chat",
  state: () => ({
    open: false,
  }),
  actions: {
    setOpen(value: boolean) {
      this.open = value;
    },
  },
  getters: {
    show() {
      const availableStatuses = [
        StatusProgress.INIT_OBJECTIVE,
      ];
      return availableStatuses.includes(useAdaptProgressStore.status);
    },
  },
});

export const useAdaptChatStore = store(instance);
